<div class="flex flex-col gap-2">
    <div class="font-bold border-b border-ponder-light border-opacity-10">
        Collections
    </div>
    <loading [isLoading]="isLoading" [success]="loadingSuccess"></loading>
    @if (!isLoading && loadingSuccess) {
        @if (isVisible) {
            @if (!collections.length) {
                <div class="text-center text-slate-500 text-sm">
                    This user has not yet added any cards to their collection.
                </div>
            } @else {
                @for (collection of collections ; track collection.game) {
                    <collection-preview [username]="username" [collectionPreview]="collection"></collection-preview>
                }
                
            }
        } @else {
            <div class="text-center text-slate-500 text-sm italic">
                Collection contents for this user are private.
            </div>
        }
    }
</div>